import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { Components } from "../components";
import { CI } from "../components/forms/questionnaires/ci";
import { SigleStep } from "../components/forms/questionnaires/SigleStep";
import logoImg from "../assets/images/logo-legafrik.png";
import { Utils } from "../utils";
import { DemandeCreateViewSuivie } from "./DemandeCreateViewSuivie";
import { Associes } from "../components/forms/questionnaires/Associes";
import { ActiviteStep } from "../components/forms/questionnaires/ActiviteStep";
import { RecapStepSarlV2 } from "../components/forms/questionnaires/ci/sarl/RecapStepSarlV2";
import { AdresseOneStep } from "../components/forms/questionnaires/AdresseOneStep";
import { AdresseTwoStep } from "../components/forms/questionnaires/AdresseTwoStep";
import { CapitalStep } from "../components/forms/questionnaires/CapitalStep";
import { GerantStep } from "../components/forms/questionnaires/GerantStep";
import { PresidentStep } from "../components/forms/questionnaires/PresidentStep_ci_sn_bf_bn";
import { DirecteurStep } from "../components/forms/questionnaires/DirecteurStep";
import { RecapStepSasV2 } from "../components/forms/questionnaires/ci/sarl/RecapStepSasV2";
import { SigleStepOng } from "../components/forms/questionnaires/SigleStepOng";
import { AssociesStatutaire } from "../components/forms/questionnaires/ci/statutaire/AssociesStatutaire";
import { InfoAssemble } from "../components/forms/questionnaires/ci/statutaire/InfoAssemble";
import { InfoModification } from "../components/forms/questionnaires/ci/statutaire/InfoModification";
import { RecapStepStatutaire } from "../components/forms/questionnaires/ci/statutaire/RecapStepStatutaire";

function QuestionnaireSuivi() {
  //   const { type_demande } = useParams();
  const abortController = useMemo(() => new AbortController(), []);

  const { state } = useLocation();
  console.log("state", state);

  const [useDemande, setUsedemande] = useState();
  const [champs_demandes, setChamps_demandes] = useState();
  const [stepIndividuelle, setStepIndividuelle] = useState();
  const [indexStep, setIndexStep] = useState(0);
  const [etapeTraitement, setEtapeTraitement] = useState(null);
  const [champs_lead, setChamps_lead] = useState();
  const [dataDemandes, setDataDemandes] = useState(null);
  const [type_demandes, setType_demandes] = useState();

  const [step, setStep] = useState(1);

  const [champs_questionnaireObject, setChamps_questionnaireObject] = useState(
    {}
  );
  const dataFormat = {
    lead: {},
    questionnaire: {},
  };

  const tiltlQuestionnaire = "Veuillez remplir le questionnaire ci-dessous";
  const QuestionnaireFormsByPaysByService = CI ? CI[type_demandes] : CI.SARL;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_HOST}/api/check/dossier/${state.reference}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then(async (data) => {
        // console.log("data.data", data);

        setDataDemandes(data);
        setType_demandes(data.data.type_demande);
        setChamps_demandes(Utils.String.parseJson(data.data.champs_demande));
      });
  }, [state.reference]);

  const handleQuetionnaireNextClick = (e, name, value, isEnd = false) => {
    e.preventDefault();

    if (name === "associes") {
      setStepIndividuelle(name);
    }
    const champs_questionnaireObjectCopy = { ...champs_questionnaireObject };

    if (name !== "infos") {
      champs_questionnaireObjectCopy[name] = value;
    } else {
      champs_questionnaireObjectCopy["activites"] = value["activites"];

      champs_questionnaireObjectCopy["sigle"] = JSON.stringify(value["sigle"]);
    }
    setChamps_questionnaireObject(champs_questionnaireObjectCopy);

    if (isEnd) return;

    setStep(step + 1);
  };

  const handleQuestionnaireBackClick = (e, value) => {
    // console.log("e", e);
    e.preventDefault();

    if (step === 1) return;

    // if (useDemande.type_demande?.libelle.includes("SAS")) {
    //   setStep(step - 2);
    // } else if (
    //   stepIndividuelle === "associes" &&
    //   useDemande.type_demande?.libelle.includes("individuelle")
    // ) {
    //   //console.log("stepIndividuelle", stepIndividuelle);
    //   setStep(step - 3);
    // } else {
    // }
    setStep(step - 1);
  };

  const handleValidateClick = (chamDemandes) => {
    // console.log("chamDemandes", chamDemandes);
    setChamps_lead(chamDemandes);
  };

  const handleQuestionnaireSubmit = async (e, name, value) => {
    e.preventDefault();

    const champs_questionnaireObjectCopy = { ...champs_questionnaireObject };
    champs_questionnaireObjectCopy[name] = value;

    setChamps_questionnaireObject(champs_questionnaireObjectCopy);
    // useDemande.setIsDisabled(true);
    // console.log("setChamps_questionnaireObject", champs_questionnaireObject);

    dataFormat["lead"].pays_id = dataDemandes.data.pays_id;
    dataFormat["lead"].montant_total = dataDemandes.data.montant_total;
    dataFormat["lead"].type_demande_id = dataDemandes.data.type_demande_id;
    dataFormat["lead"].champs_demande = JSON.stringify(champs_lead);

    dataFormat["lead"].dossier_id = dataDemandes.data.dossier_id;
    dataFormat["lead"].organisation_id = dataDemandes.data.organisation_id;
    dataFormat["questionnaire"].champs_questionnaire = JSON.stringify(
      champs_questionnaireObjectCopy
    );
    //   {
    //     "lead": {
    //     "pays_id": 1,
    //     "champs_demande": "{\"nom\":\"aze\",\"prenom\":\"aze\",\"numero-telephone\":\"2250747362864\",\"email\":\"d.lemec93@gmail.com\",\"denomination\":[\"Me\"],\"secteur-activite\":\"Commerce general\",\"entreprise-anterieur\":\"Non\",\"date-reception-certificat\":\"1 semaine\",\"localisation-ville\":\"15000\",\"localisation-siege\":\"Je domicilie à Legafrik (30 000 FCFA/mois)\",\"capital-social\":\"100 000 FCFA\",\"banque\":\"Bank\"}",
    //     "montant_total": null,
    //     "type_demande_id": "73",
    //     "dossier_id": 1595,
    //     "organisation_id": 6
    //     },
    //     "questionnaire": {
    //         "champs_questionnaire": "{\"sigle\":\"{}\",\"adresse\":\"\",\"associes\":\"[{\\\"type\\\":\\\"particulier\\\",\\\"nom\\\":\\\"zer\\\",\\\"prenoms\\\":\\\"zer\\\",\\\"numero-telephone\\\":\\\"2250747362864\\\",\\\"date-naissance\\\":\\\"2024-07-02\\\",\\\"numero-piece-identite\\\":\\\"aze\\\",\\\"type-piece-identite\\\":\\\"CNI\\\",\\\"pays-piece-identite\\\":\\\"aze\\\",\\\"date-piece-identite\\\":\\\"2024-07-01\\\",\\\"date-fin-validite-piece-identite\\\":\\\"2024-07-01\\\",\\\"civilite\\\":\\\"monsieur\\\",\\\"lieu-naissance\\\":\\\"Abidjan\\\",\\\"adresse\\\":\\\"Abidjan\\\",\\\"pays-naissance\\\":\\\"aze\\\",\\\"nationalite\\\":\\\"aze\\\",\\\"adresse-mail\\\":\\\"d.lemec93+aze@gmail.com\\\",\\\"situation-matrimoniale\\\":\\\"celibataire\\\"}]\",\"activites\":\"Activité1; Activité2; Activité3\",\"\":\"\"}"
    //     }
    // }
    // console.log("dataFormat", dataFormat);

    try {
      fetch(
        `${process.env.REACT_APP_HOST}/api/submit/demande/${dataDemandes.data.id}`,
        {
          method: "PUT",
          body: JSON.stringify(dataFormat),
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(async (data) => {
          console.log("data.data", data.data);

          // setDataDemandes(data.data);
          // setType_demandes(data.data.type_demande);
          // setChamps_demandes(Utils.String.parseJson(data.data.champs_demande));
        });
    } catch (error) {
      if ("messages" in error) return;
      //Toaster
    } finally {
      // useDemande.setIsDisabled(false);
    }
  };

  const handleNextClicked = (steped) => {
    setStep(step + 1);
  };
  console.log("dataDemandes", dataDemandes);

  // const handleNextClick = (e) => {
  //   e.preventDefault();

  //   const stepEtapeTraitmentIndex = etape_traitements.findIndex(
  //     (etape_traitement) => step === etape_traitement.libelle
  //   );
  //   const nextStepEtapeTraitemnt =
  //     etape_traitements[stepEtapeTraitmentIndex - 1];

  //   if (!nextStepEtapeTraitemnt || nextStepEtapeTraitemnt === undefined) return;

  //   setStep(nextStepEtapeTraitemnt.libelle);
  //   setEtapeTraitement(nextStepEtapeTraitemnt);
  // };

  // const  param1 = location.state || {};
  // const reference = useParams();
  if (dataDemandes) {
    // <h1 className="text-3xl font-bold text-center my-5">
    //   {tiltlQuestionnaire}
    // </h1>;

    if (dataDemandes.status === "traitement") {
      return (
        <div className="my-32 mx-auto md:w-1/2 lg:w-1/3 text-center ">
          <div className="flex justify-center">
            <img
              alt="Midone Tailwind HTML Admin Template"
              className="w-24 -intro-x"
              src={logoImg}
            />
          </div>
          <div className=" ">
            <p className="-intro-x text-dark-1 font-medium text-2xl leading-tight my-5">
              Votre dossier est à l'étape :
            </p>
            <p className="-intro-x text-danger font-medium text-2xl leading-tight ">
              {dataDemandes.message}</p>
          </div>
        </div>
      );
    } else {
      if (type_demandes.libelle.includes("individuelle")) {
        return (
          /**
           * Questionnaire
           */
          <div className="grid grid-cols-12 mt-5">
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
              <SigleStep
                index={2}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                stated={"suivie"}
                nomSociete={
                  champs_demandes ? champs_demandes["denomination"][0] : ""
                }
              />
              <Associes
                index={3}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                demande={type_demandes}
                nombreAssocies={champs_demandes["nombre-associes"]}
              />
              <ActiviteStep
                index={4}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
              <RecapStepSarlV2
                index={5}
                step={step}
                handleSubmit={handleQuestionnaireSubmit}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                champsDemandeObject={champs_demandes}
                questionnaireObject={champs_questionnaireObject}
                demande={type_demandes}
              />
            </div>
          </div>
        );
      } else if (type_demandes.libelle.includes("SARL")) {
        return (
          <div className="grid grid-cols-12 mt-5">
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
            </div>
            <SigleStep
              index={2}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              nomSociete={
                champs_demandes ? champs_demandes["denomination"][0] : ""
              }
            />

            <Components.OptionalStep
              isOptional={
                step === 3 &&
                champs_demandes["localisation-siege"]?.includes("Legafrik")
              }
              callback={() =>
                handleQuetionnaireNextClick(new Event("click"), "adresse", "")
              }
            >
              <AdresseOneStep
                index={3}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
            </Components.OptionalStep>

            <Components.OptionalStep
              isOptional={
                step === 4 &&
                champs_demandes["localisation-siege"]?.includes("Legafrik")
              }
              callback={() =>
                handleQuetionnaireNextClick(new Event("click"), "adresse", "")
              }
            >
              <AdresseTwoStep
                index={4}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                adresseNew={champs_questionnaireObject["adresse"] ?? "{}"}
              />
            </Components.OptionalStep>

            <Associes
              index={5}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              demande={type_demandes}
              nombreAssocies={champs_demandes["nombre-associes"]}
              chamDemandes={champs_demandes}
            />

            <CapitalStep
              index={6}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              capitalSocial={champs_demandes["capital-social"]}
              associes={champs_questionnaireObject["associes"] ?? "[]"}
            />

            <ActiviteStep
              index={7}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
            />

            <GerantStep
              index={8}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              associes={champs_questionnaireObject["associes"] ?? "[]"}
            />

            <RecapStepSarlV2
              index={9}
              step={step}
              handleSubmit={handleQuestionnaireSubmit}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              champsDemandeObject={champs_demandes}
              questionnaireObject={champs_questionnaireObject}
            />
          </div>
        );
      } else if (type_demandes.libelle.includes("SARLU")) {
        return (
          <div className="grid grid-cols-12 mt-5">
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
            </div>
            <SigleStep
              index={2}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              nomSociete={
                champs_demandes ? champs_demandes["denomination"][0] : ""
              }
            />

            <Components.OptionalStep
              isOptional={
                step === 3 &&
                champs_demandes["localisation-siege"]?.includes("Legafrik")
              }
              callback={() =>
                handleQuetionnaireNextClick(new Event("click"), "adresse", "")
              }
            >
              <QuestionnaireFormsByPaysByService.AdresseOneStepSarlUni
                index={3}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
            </Components.OptionalStep>

            <Components.OptionalStep
              isOptional={
                step === 4 &&
                champs_demandes["localisation-siege"]?.includes("Legafrik")
              }
              callback={() =>
                handleQuetionnaireNextClick(new Event("click"), "adresse", "")
              }
            >
              <QuestionnaireFormsByPaysByService.AdresseTwoStepSarlUni
                index={4}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                adresseNew={champs_questionnaireObject["adresse"] ?? "{}"}
              />
            </Components.OptionalStep>

            <QuestionnaireFormsByPaysByService.AssocieTypesSarlUni
              index={5}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              demande={type_demandes}
              nombreAssocies={champs_demandes["nombre-associes"]}
            />

            <QuestionnaireFormsByPaysByService.AssociesSarlUni
              index={5}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              nombreAssocies={champs_demandes["nombre-associes"]}
              capitalSocial={champs_demandes["capital-social"]}
              associeTypes={champs_questionnaireObject["associeTypes"] ?? "[]"}
            />

            <QuestionnaireFormsByPaysByService.ActiviteStepSarlUni
              index={6}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
            />

            <GerantStep
              index={7}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              associes={champs_questionnaireObject["associes"] ?? "[]"}
            />

            <RecapStepSarlV2
              index={8}
              step={step}
              handleSubmit={handleQuestionnaireSubmit}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              champsDemandeObject={champs_demandes}
              questionnaireObject={champs_questionnaireObject}
            />
          </div>
        );
      } else if (type_demandes.libelle.includes("SASU")) {
        return (
          <div className="grid grid-cols-12 mt-5">
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
              <SigleStep
                index={2}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                nomSociete={champs_demandes["denomination"]}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <Components.OptionalStep
                isOptional={
                  step === 3 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseOneStepSasUni
                  index={3}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                />
              </Components.OptionalStep>

              <Components.OptionalStep
                isOptional={
                  step === 4 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseTwoStepSasUni
                  index={4}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                  adresseNew={champs_questionnaireObject["adresse"] ?? "{}"}
                />
              </Components.OptionalStep>

              <QuestionnaireFormsByPaysByService.AssocieTypesSasUni
                index={5}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                nombreAssocies={champs_demandes["nombre-associes"]}
              />

              <QuestionnaireFormsByPaysByService.AssociesSasUni
                index={6}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                nombreAssocies={champs_demandes["nombre-associes"]}
                capitalSocial={champs_demandes["capital-social"]}
                associeTypes={
                  champs_questionnaireObject["associeTypes"] ?? "[]"
                }
              />

              <QuestionnaireFormsByPaysByService.ActiviteStepSasUni
                index={7}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <PresidentStep
                index={8}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />

              <DirecteurStep
                index={9}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />

              <RecapStepSasV2
                index={10}
                step={step}
                handleSubmit={handleQuestionnaireSubmit}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                champsDemandeObject={Utils.String.parseJson(
                  useDemande.champs_demande
                )}
                questionnaireObject={champs_questionnaireObject}
              />
            </div>
          </div>
        );
      } else if (type_demandes.libelle.includes("SAS")) {
        return (
          <div className="grid grid-cols-12 mt-5">
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
              <SigleStep
                index={2}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                nomSociete={champs_demandes["denomination"]}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <Components.OptionalStep
                isOptional={
                  step === 3 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseOneStepSas
                  index={3}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                />
              </Components.OptionalStep>

              <Components.OptionalStep
                isOptional={
                  step === 4 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseTwoStepSas
                  index={4}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                  adresseNew={champs_questionnaireObject["adresse"] ?? "{}"}
                />
              </Components.OptionalStep>

              <Associes
                index={5}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                nombreAssocies={champs_demandes["nombre-associes"]}
              />

              <QuestionnaireFormsByPaysByService.ActiviteStepSas
                index={6}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <CapitalStep
                index={7}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                capitalSocial={champs_demandes["capital-social"]}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />

              <PresidentStep
                index={8}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />

              <DirecteurStep
                index={9}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />

              <RecapStepSasV2
                index={10}
                step={step}
                handleSubmit={handleQuestionnaireSubmit}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                champsDemandeObject={Utils.String.parseJson(
                  useDemande.champs_demande
                )}
                questionnaireObject={champs_questionnaireObject}
              />
            </div>
          </div>
        );
      } else if (type_demandes.libelle.includes("Association")) {
        // else  {
        return (
          <div className="grid grid-cols-12 mt-5">
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
              <QuestionnaireFormsByPaysByService.SigleStepAssociation
                index={2}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                nomSociete={champs_demandes["denomination"]}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
              <QuestionnaireFormsByPaysByService.AdresseOneStepAssociation
                index={3}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <QuestionnaireFormsByPaysByService.AdresseTwoStepAssociation
                index={4}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                adresseNew={champs_questionnaireObject["adresse"] ?? "{}"}
              >
                <Components.OptionalStep
                  isOptional={
                    step === 4 &&
                    champs_demandes["localisation-siege"]?.includes("Legafrik")
                  }
                  callback={() =>
                    handleQuetionnaireNextClick(
                      new Event("click"),
                      "adresse",
                      ""
                    )
                  }
                ></Components.OptionalStep>
              </QuestionnaireFormsByPaysByService.AdresseTwoStepAssociation>
              <QuestionnaireFormsByPaysByService.ActiviteStepAssociation
                index={5}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
              <QuestionnaireFormsByPaysByService.PresidentAssociation
                index={6}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
              <QuestionnaireFormsByPaysByService.SecretaireGeneralAssociation
                index={7}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <QuestionnaireFormsByPaysByService.TresorierAssociation
                index={8}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                capitalSocial={champs_demandes["capital-social"]}
              />
              <QuestionnaireFormsByPaysByService.BureauAssociation
                index={9}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
              <QuestionnaireFormsByPaysByService.CommissaireAssociation
                index={10}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.CommissaireAssociationAdjoint
                index={11}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.DureAssociation
                index={12}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.MontantAssociation
                index={13}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.RecapStepAssopciation
                index={14}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                questionnaireObject={champs_questionnaireObject}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
            </div>
          </div>
        );
      } else if (type_demandes.libelle.includes("ONG")) {
        // else  {
        return (
          <div className="grid grid-cols-12 mt-5">
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
              <SigleStepOng
                index={2}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                nomSociete={champs_demandes["denomination"]}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <Components.OptionalStep
                isOptional={
                  step === 3 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseOneStepOng
                  index={3}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                />
              </Components.OptionalStep>

              <Components.OptionalStep
                isOptional={
                  step === 4 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseTwoStepOng
                  index={4}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                  adresseNew={champs_questionnaireObject["adresse"] ?? "{}"}
                />
              </Components.OptionalStep>
              <QuestionnaireFormsByPaysByService.ActiviteStepOng
                index={5}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
              <QuestionnaireFormsByPaysByService.PresidentOng
                index={6}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <QuestionnaireFormsByPaysByService.SecretaireGeneralOng
                index={7}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <QuestionnaireFormsByPaysByService.TresorierOng
                index={8}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                capitalSocial={champs_demandes["capital-social"]}
              />

              <QuestionnaireFormsByPaysByService.BureauOng
                index={9}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <QuestionnaireFormsByPaysByService.CommissaireOng
                index={10}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />

              <QuestionnaireFormsByPaysByService.CommissaireOngAjoint
                index={11}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.DureOng
                index={12}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.MontantOng
                index={13}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.RecapStepOng
                index={14}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                questionnaireObject={champs_questionnaireObject}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
            </div>
          </div>
        );
      } else if (type_demandes.libelle.includes("Fondation")) {
        // else  {
        return (
          <div className="grid grid-cols-12 mt-5">
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
              <QuestionnaireFormsByPaysByService.SigleStepFondation
                index={2}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                nomSociete={champs_demandes["denomination"]}
              />

              <Components.OptionalStep
                isOptional={
                  step === 3 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseOneStepFondation
                  index={3}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                />
              </Components.OptionalStep>

              <Components.OptionalStep
                isOptional={
                  step === 4 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseTwoStepFondation
                  index={4}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                  adresseNew={champs_questionnaireObject["adresse"] ?? "{}"}
                />
              </Components.OptionalStep>
              <QuestionnaireFormsByPaysByService.ActiviteStepFondation
                index={5}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
              <QuestionnaireFormsByPaysByService.PresidentFondation
                index={6}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <QuestionnaireFormsByPaysByService.SecretaireGeneralFondation
                index={7}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <QuestionnaireFormsByPaysByService.TresorierFondation
                index={8}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                capitalSocial={champs_demandes["capital-social"]}
              />

              <QuestionnaireFormsByPaysByService.BureauFondation
                index={9}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <QuestionnaireFormsByPaysByService.CommissaireFondation
                index={10}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.CommissaireFondationAdjoint
                index={11}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                associes={champs_questionnaireObject["associes"] ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.DureFondation
                index={12}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.MontantFondation
                index={13}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
              <QuestionnaireFormsByPaysByService.RecapStepFondation
                index={14}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                questionnaireObject={champs_questionnaireObject}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
            </div>
          </div>
        );
      } else if (type_demandes.libelle.includes("Recouvrement")) {
        return (
          <div className="grid grid-cols-12 mt-5">
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
              <QuestionnaireFormsByPaysByService.SigleStepRecouvre
                index={2}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                nomSociete={champs_demandes["entreprise-debitrice"]}
              />

              <Components.OptionalStep
                isOptional={
                  step === 3 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseOneStepRecouvre
                  index={3}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                />
              </Components.OptionalStep>

              <Components.OptionalStep
                isOptional={
                  step === 4 &&
                  champs_demandes["localisation-siege"]?.includes("Legafrik")
                }
                callback={() =>
                  handleQuetionnaireNextClick(new Event("click"), "adresse", "")
                }
              >
                <QuestionnaireFormsByPaysByService.AdresseTwoStepRecouvre
                  index={4}
                  step={step}
                  handleNextClick={handleQuetionnaireNextClick}
                  handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                  adresseNew={champs_questionnaireObject["adresse"] ?? "{}"}
                />
              </Components.OptionalStep>

              {/* <ActiviteStepRecouv
              index={4}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
            /> */}
              <QuestionnaireFormsByPaysByService.FacturesRecouvre
                index={5}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />

              <QuestionnaireFormsByPaysByService.CommentRecouvre
                index={6}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              />
              {/* <SecretaireGeneralRecouvre
              index={5}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
            />
    
            <TresorierRecouvre
              index={6}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              capitalSocial={champs_demandes["capital-social"]}
            />
    
            <BureauRecouvre
              index={7}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
            />
    
            <CommissaireRecouvre
              index={8}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              associes={champs_questionnaireObject["associes"] ?? "[]"}
            />
    
            <DureRecouvre
              index={9}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              handleSubmit={handleSubmit}
              dataGlobal={champs_demandes ?? "[]"}
            />
            <MontantRecouvre
              index={10}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              handleSubmit={handleSubmit}
              dataGlobal={champs_demandes ?? "[]"}
            /> */}
              <QuestionnaireFormsByPaysByService.RecapStepRecouvre
                index={7}
                step={step}
                handleNextClick={handleQuetionnaireNextClick}
                handleQuestionnaireBackClick={handleQuestionnaireBackClick}
                questionnaireObject={champs_questionnaireObject}
                handleSubmit={handleQuestionnaireSubmit}
                dataGlobal={champs_demandes ?? "[]"}
              />
            </div>
          </div>
        );
      } else if (type_demandes.libelle.includes("statutaire")) {
        return (
          <div className="grid grid-cols-12 mt-5">
            {/* <SigleStep
              index={1}
              step={step}Sas
              handleNextClick={handleNextClick}
              nomSociete={champs_demandes["denomination"]}
            /> */}
            {step && step === 1 && (
              <DemandeCreateViewSuivie
                index={1}
                paraPays={state.paraPays}
                type_demandes={type_demandes}
                champs_demandes={champs_demandes}
                handleNextClick={handleNextClicked}
                handleValidateClick={handleValidateClick}
              />
            )}
            <div className="col-span-12">
              {step > 1 ? (
                <h1 className="text-3xl font-bold text-center my-5">
                  {tiltlQuestionnaire}
                </h1>
              ) : null}
            </div>

            <AssociesStatutaire
              index={2}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              nomSociete={champs_demandes["denomination"][0]}
            />

            {/* <AdresseTwoStepSas
                index={3}
                step={step}
                handleNextClick={handleNextClick}
                handleQuestionnaireBackClick={
                  handleQuestionnaireBackClick
                }
                adresseNew={
                  champs_questionnaireObject["adresse"] ?? "{}"
                }
              /> */}

            <InfoAssemble
              index={3}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              nombreAssocies={champs_demandes["nombre-associes"]}
              type_demande={type_demandes}
            />

            <InfoModification
              index={4}
              step={step}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              associes={champs_questionnaireObject["associes"] ?? "[]"}
              chamDemande={champs_demandes}
            />
            {/* <PresidentStep
              index={4}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              associes={champs_questionnaireObject["associes"] ?? "[]"}
            /> */}

            {/* <ActiviteStepSas
              index={5}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
            />
    
            <CapitalStep
              index={6}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              capitalSocial={champs_demandes["capital-social"]}
              associes={champs_questionnaireObject["associes"] ?? "[]"}
            />
    
           
            <DirecteurStep
              index={8}
              step={step}
              handleNextClick={handleNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              associes={champs_questionnaireObject["associes"] ?? "[]"}
            />
    */}
            <RecapStepStatutaire
              index={5}
              step={step}
              handleSubmit={handleQuestionnaireSubmit}
              handleNextClick={handleQuetionnaireNextClick}
              handleQuestionnaireBackClick={handleQuestionnaireBackClick}
              champsDemandeObject={champs_demandes}
              questionnaireObject={champs_questionnaireObject}
              dataGlobal={champs_demandes ?? "[]"}
            />
          </div>
        );
      }
    }
  }
  return <div>Pas de questionnaire</div>;
}

export default QuestionnaireSuivi;
